import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { SvgIcon } from '@/components/SvgIcon';

import Button from '@/components/atoms/Button';
import Heading from '@/components/atoms/Heading';
import { Text } from '@/components/atoms/Text';

import iconFaceSadSrc from '~/icons/face-sad.svg';

type ErrorPageProps = {
  onSubmit?: () => void;
  isModal?: boolean;
};

export function ErrorPage({ onSubmit, isModal }: ErrorPageProps) {
  const { texts } = useTranslation();

  return (
    <div
      className={cn(
        'flex flex-col items-start justify-center md:h-full lg:items-center',
        isModal && 'lg:items-start'
      )}
    >
      <div
        className={cn(
          'mb-6 flex w-full items-center justify-start gap-4 lg:justify-center',
          isModal && 'lg:justify-start'
        )}
      >
        <SvgIcon src={iconFaceSadSrc} className='text-error-500 h-8 w-8' />
        <Heading level='h3'>
          {texts.contact_sales.error.something_went_wrong}
        </Heading>
      </div>
      <Text
        color='gray-dark-500'
        classNames={{
          wrapper: cn('mb-9 lg:text-center', isModal && 'lg:text-left'),
        }}
      >
        {texts.contact_sales.error.message_decodo}
      </Text>
      <Button
        onClick={onSubmit}
        classNames={{
          root: cn('lg:w-auto w-full lg:min-w-[320px]', isModal && 'lg:w-full'),
        }}
      >
        {texts.contact_sales.error.try_again}
      </Button>
    </div>
  );
}
